module.exports = __webpack_public_path__ + "static/media/desktoporlaptop.c1bbcad8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/desktoporlaptop.png
// module id = 345
// module chunks = 0